import { render, staticRenderFns } from "./StudioElettrofisiologicoList.vue?vue&type=template&id=67d3b2b5"
import script from "./StudioElettrofisiologicoList.vue?vue&type=script&lang=js"
export * from "./StudioElettrofisiologicoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports